import { render, staticRenderFns } from "./RecognitionsCard.vue?vue&type=template&id=80f996c8&scoped=true&"
import script from "./RecognitionsCard.vue?vue&type=script&lang=js&"
export * from "./RecognitionsCard.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionsCard.vue?vue&type=style&index=0&id=80f996c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f996c8",
  null
  
)

export default component.exports